import { Component, type ErrorInfo, type ReactNode } from 'react'

import { ErrorScreen } from './Screens.js'

/**
 * Poslední záchranná síť.
 *
 * Původní aplikace neměla žádnou — jakákoli neošetřená výjimka
 * (a bylo jich tam několik) skončila trvale bílou obrazovkou
 * bez jediné informace a bez cesty dál.
 */

interface Props {
  children: ReactNode
}

interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Až se zapojí sledování chyb (Sentry), hlášení půjde odsud.
    console.error('Neošetřená chyba aplikace', error, info.componentStack)
  }

  override render(): ReactNode {
    const { error } = this.state
    if (!error) return this.props.children

    return (
      <ErrorScreen
        title="Něco se pokazilo"
        detail="Aplikaci se nepodařilo pokračovat. Zkuste stránku načíst znovu."
        onRetry={() => window.location.reload()}
        onSkip={() => {
          window.location.href = '/'
        }}
        skipLabel="Na úvod"
      />
    )
  }
}
